import React, { useCallback, useState } from 'react';
import { Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { toast } from 'react-toastify';
import useStyles from './AlterarPercentuaisProcesso.style';
import {
  TITULO_PAGINA,
  SUBTITULO_PAGINA,
  MAX_LENGTH_NUM_PROCESSO,
  MINIMO_PALAVRAS_JUSTIFICATIVA,
  MAX_COUNTER_JUSTIFICATIVA,
  LABEL_NUMERO_PROCESSO,
  LABEL_PERCENTUAL_RECEBIMENTO,
  LABEL_PERCENTUAL_PAGAMENTO_DIRETO,
  LABEL_JUSTIFICATIVA,
  LABEL_ALTERAR,
  MENSAGEM_ERRO_BUSCA_PROCESSO,
  MENSAGEM_ERRO_VERIFICAR_LANCAMENTO,
  MENSAGEM_BLOQUEIO_LANCAMENTO_FICHA_FINANCEIRA,
  MENSAGEM_SUCESSO_ALTERACAO,
  MENSAGEM_ERRO_ALTERACAO,
  MENSAGEM_CONFIRMACAO_ALTERACAO,
  MENSAGEM_ERRO_HISTORICO_AUTOMATICO,
} from './alterarPercentuaisProcesso.constants';
import LoadingUI from '../../../components/UI/Loading/LoadingUI';
import WrapperSubTitleForm from '../../../components/UI/WrapperSubTitleForm/WrapperSubTitleForm';
import Grid24 from '../../../components/UI/Grid24/Grid24';
import { ButtonUI, TextareaField } from '../../../components';
import NumberInput from '../../../components/UI/Field/Number/NumberInput';
import OptionDialogNew from '../../../components/UI/Dialogs/OptionDialog/OptionDialogNew';
import { SearchButton } from '../../../components/SearchButton/SeachButton';
import { getExceptionMessage, possuiMinimoPalavras } from '../../../helpers';
import {
  findPercentuaisAtuaisByNumProcesso,
  updatePercentuaisDoProcesso,
} from '../../../services/core/manutencao/manutencao.service';
import { findFichaFinanceiraAnalitica } from '../../../services/core/processos/processosFichaFinanceira';
import { inserirNovoHistorico } from '../../../services/core/processos/processosService';
import { tiposHistoricos } from '../../../types/tiposHistoricoTypes';

function paraNumeroValido(valor) {
  if (valor === '' || valor == null) {
    return null;
  }
  const numero = Number(valor);
  return Number.isNaN(numero) ? null : numero;
}

function formatarPercentual(valor) {
  return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
}

function montarTextoHistoricoAlteracao({
  pagtoDiretoAlterado, comissaoAlterada, percentuaisAtuais, comissaoNova, pagtoDiretoNovo, motivo,
}) {
  const partes = [];
  if (pagtoDiretoAlterado) {
    partes.push(`pagamento direto de ${formatarPercentual(percentuaisAtuais.porcentagemPagtoDireto)}% para ${formatarPercentual(pagtoDiretoNovo)}%`);
  }
  if (comissaoAlterada) {
    partes.push(`recebimento de ${formatarPercentual(percentuaisAtuais.porcentagemComissao)}% para ${formatarPercentual(comissaoNova)}%`);
  }
  if (partes.length === 0) {
    throw new Error('montarTextoHistoricoAlteracao chamada sem nenhum percentual alterado');
  }
  return `Alterado o percentual de ${partes.join(' e o percentual de ')} do processo, motivo: ${motivo}`;
}

export default function AlterarPercentuaisProcesso() {
  const style = useStyles();

  const [loading, setLoading] = useState(false);
  const [numProcesso, setNumProcesso] = useState('');
  const [percentuaisAtuais, setPercentuaisAtuais] = useState(null);
  const [percentualComissaoNovo, setPercentualComissaoNovo] = useState('');
  const [percentualPagtoDiretoNovo, setPercentualPagtoDiretoNovo] = useState('');
  const [justificativa, setJustificativa] = useState('');

  const [confirmacaoAberta, setConfirmacaoAberta] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [loadingLancamento, setLoadingLancamento] = useState(false);
  const [bloqueadoPorLancamento, setBloqueadoPorLancamento] = useState(false);
  const [podeAlterar, setPodeAlterar] = useState(false);

  const verificarLancamentoFichaFinanceira = useCallback((idProcesso) => {
    setLoadingLancamento(true);
    findFichaFinanceiraAnalitica(idProcesso, 0, 1, ['dataLancamento,DESC']).then((response) => {
      const possuiLancamento = (response.data?.totalElements ?? 0) > 0;
      setBloqueadoPorLancamento(possuiLancamento);
      setPodeAlterar(!possuiLancamento);
    }).catch((exception) => {
      toast.error(getExceptionMessage(exception) || MENSAGEM_ERRO_VERIFICAR_LANCAMENTO);
      setBloqueadoPorLancamento(false);
      setPodeAlterar(false);
    }).finally(() => {
      setLoadingLancamento(false);
    });
  }, []);

  const buscarProcesso = useCallback((numero) => {
    setLoading(true);
    setPercentuaisAtuais(null);
    setPercentualComissaoNovo('');
    setPercentualPagtoDiretoNovo('');
    setJustificativa('');
    setBloqueadoPorLancamento(false);
    setPodeAlterar(false);
    return findPercentuaisAtuaisByNumProcesso(numero).then((response) => {
      if (!response?.data || response.data.porcentagemComissao == null
        || response.data.porcentagemPagtoDireto == null) {
        throw new Error('Resposta da busca de processo fora do contrato esperado');
      }
      setPercentuaisAtuais(response.data);
      setPercentualComissaoNovo(response.data.porcentagemComissao);
      setPercentualPagtoDiretoNovo(response.data.porcentagemPagtoDireto);
      verificarLancamentoFichaFinanceira(numero);
    }).catch((exception) => {
      setPercentuaisAtuais(null);
      setPodeAlterar(false);
      toast.error(getExceptionMessage(exception) || MENSAGEM_ERRO_BUSCA_PROCESSO);
    }).finally(() => {
      setLoading(false);
    });
  }, [verificarLancamentoFichaFinanceira]);

  const handleSubmitSearchForm = useCallback((e) => {
    e.preventDefault();
    buscarProcesso(numProcesso);
  }, [buscarProcesso, numProcesso]);

  const handleChangeNumProcesso = useCallback((e) => {
    const { value } = e.target;
    setNumProcesso(value);
  }, []);

  const fecharBloqueio = useCallback(() => {
    setBloqueadoPorLancamento(false);
  }, []);

  const handleChangePercentualComissao = useCallback((e) => {
    setPercentualComissaoNovo(e.target.value);
  }, []);

  const handleChangePercentualPagtoDireto = useCallback((e) => {
    setPercentualPagtoDiretoNovo(e.target.value);
  }, []);

  const handleChangeJustificativa = useCallback((e) => {
    setJustificativa(e.target.value);
  }, []);

  const abrirConfirmacao = useCallback(() => {
    setConfirmacaoAberta(true);
  }, []);

  const fecharConfirmacao = useCallback(() => {
    setConfirmacaoAberta(false);
  }, []);

  const comissaoNova = paraNumeroValido(percentualComissaoNovo);
  const pagtoDiretoNovo = paraNumeroValido(percentualPagtoDiretoNovo);
  const comissaoAlterada = percentuaisAtuais != null && comissaoNova != null
    && comissaoNova !== Number(percentuaisAtuais.porcentagemComissao);
  const pagtoDiretoAlterado = percentuaisAtuais != null && pagtoDiretoNovo != null
    && pagtoDiretoNovo !== Number(percentuaisAtuais.porcentagemPagtoDireto);
  const algumPercentualAlterado = comissaoAlterada || pagtoDiretoAlterado;
  const justificativaValida = possuiMinimoPalavras(justificativa, MINIMO_PALAVRAS_JUSTIFICATIVA);
  const habilitarBotaoAlterar = algumPercentualAlterado && justificativaValida
    && comissaoNova != null && pagtoDiretoNovo != null;

  const confirmarAlteracao = useCallback(() => {
    const motivo = justificativa.trim();

    setLoadingSubmit(true);
    updatePercentuaisDoProcesso(numProcesso, comissaoNova, pagtoDiretoNovo, motivo)
      .then(() => {
        toast.success(MENSAGEM_SUCESSO_ALTERACAO);
        const texto = montarTextoHistoricoAlteracao({
          pagtoDiretoAlterado,
          comissaoAlterada,
          percentuaisAtuais,
          comissaoNova,
          pagtoDiretoNovo,
          motivo,
        });
        inserirNovoHistorico(numProcesso, tiposHistoricos.COMENTARIO_AUTOMATIO.key, texto).catch(() => {
          toast.warn(MENSAGEM_ERRO_HISTORICO_AUTOMATICO);
        });
        return buscarProcesso(numProcesso);
      })
      .catch((exception) => {
        toast.error(getExceptionMessage(exception) || MENSAGEM_ERRO_ALTERACAO);
      })
      .finally(() => {
        setLoadingSubmit(false);
        setConfirmacaoAberta(false);
      });
  }, [
    numProcesso, comissaoNova, pagtoDiretoNovo, justificativa, buscarProcesso,
    comissaoAlterada, pagtoDiretoAlterado, percentuaisAtuais,
  ]);

  return (
    <WrapperSubTitleForm title={TITULO_PAGINA} className={style.pageRoot}>
      <LoadingUI show={loading || loadingLancamento || loadingSubmit} />
      <Typography>{SUBTITULO_PAGINA}</Typography>

      <form onSubmit={handleSubmitSearchForm}>
        <Grid24 container isFormContainer spacing="1" className={style.formSection}>
          <Grid24 xs={24} sm={6}>
            <NumberInput
              isForm
              fullWidth
              numberType="integer"
              name="numProcesso"
              label={LABEL_NUMERO_PROCESSO}
              value={numProcesso}
              onChange={handleChangeNumProcesso}
              maxLength={MAX_LENGTH_NUM_PROCESSO}
              acceptEmptyValue
            />
          </Grid24>
          <Grid24 xs={24} sm={2}>
            <SearchButton
              className={style.searchButtonCircular}
              type="submit"
              disabled={numProcesso.trim() === '' || loading || loadingLancamento}
            >
              <SearchIcon />
            </SearchButton>
          </Grid24>
        </Grid24>
      </form>

      {percentuaisAtuais && podeAlterar && (
        <Grid24 container isFormContainer spacing="1" className={style.formSection}>
          <Grid24 xs={24} sm={6}>
            <NumberInput
              isForm
              fullWidth
              numberType="percentage"
              maxValue={100}
              sideText="%"
              name="percentualComissaoNovo"
              label={LABEL_PERCENTUAL_RECEBIMENTO}
              value={percentualComissaoNovo}
              onChange={handleChangePercentualComissao}
            />
          </Grid24>
          <Grid24 xs={24} sm={6}>
            <NumberInput
              isForm
              fullWidth
              numberType="percentage"
              maxValue={100}
              sideText="%"
              name="percentualPagtoDiretoNovo"
              label={LABEL_PERCENTUAL_PAGAMENTO_DIRETO}
              value={percentualPagtoDiretoNovo}
              onChange={handleChangePercentualPagtoDireto}
            />
          </Grid24>
        </Grid24>
      )}

      {percentuaisAtuais && podeAlterar && (
        <>
          <Grid24 container isFormContainer spacing="1" className={style.formSection}>
            <Grid24 xs={24} sm={14}>
              <TextareaField
                isForm
                fullWidth
                label={LABEL_JUSTIFICATIVA}
                name="justificativa"
                value={justificativa}
                onChange={handleChangeJustificativa}
                showCounter
                maxCounter={MAX_COUNTER_JUSTIFICATIVA}
              />
            </Grid24>
          </Grid24>

          <Grid24 container isFormContainer spacing="1" className={style.formSection}>
            <Grid24 xs={24} sm={4}>
              <ButtonUI
                color="success"
                onClick={abrirConfirmacao}
                disabled={!habilitarBotaoAlterar}
              >
                {LABEL_ALTERAR}
              </ButtonUI>
            </Grid24>
          </Grid24>
        </>
      )}

      <OptionDialogNew
        open={bloqueadoPorLancamento}
        onClickConfirm={fecharBloqueio}
        confirmLabel="OK"
      >
        <p>{MENSAGEM_BLOQUEIO_LANCAMENTO_FICHA_FINANCEIRA}</p>
      </OptionDialogNew>

      <OptionDialogNew
        open={confirmacaoAberta}
        onClickCancel={fecharConfirmacao}
        onClickConfirm={confirmarAlteracao}
        confirmLabel="Confirmar"
        cancelLabel="Cancelar"
      >
        <p>{MENSAGEM_CONFIRMACAO_ALTERACAO}</p>
      </OptionDialogNew>
    </WrapperSubTitleForm>
  );
}
